export default {"src":"/_next/static/media/stiftelsen-sapling-badge-filled.fdf98545.svg","height":353,"width":353,"blurWidth":0,"blurHeight":0};